import { render, staticRenderFns } from "./check_do.vue?vue&type=template&id=64132df9&scoped=true"
import script from "./check_do.vue?vue&type=script&lang=js"
export * from "./check_do.vue?vue&type=script&lang=js"
import style0 from "./check_do.vue?vue&type=style&index=0&id=64132df9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64132df9",
  null
  
)

export default component.exports